import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { getQueryStyle } from "../FormCategories";

const QueryDetailsDrawer = ({ query, isOpen, onClose, onAction }) => {
  const [currentStatus, setCurrentStatus] = useState("");

  if (!query) return null;

  const badgeStyle = getQueryStyle(query.formCategory);
  const STATUS_OPTIONS = ["pending", "resolved", "unresolved"];

  const handleStatusChange = (newStatus) => {
    setCurrentStatus(newStatus);
    onAction("updateStatus", query.id, newStatus);
  };



  return (
    <AnimatePresence>
      {isOpen && (
        <>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
            className="fixed inset-0 bg-[#0B1C2D]/30 backdrop-blur-sm z-[1100]"
          />
          <motion.div
            initial={{ x: "100%" }}
            animate={{ x: 0 }}
            exit={{ x: "100%" }}
            className="fixed top-0 right-0 h-[100dvh] w-full sm:w-[500px] bg-white shadow-2xl z-[1101] flex flex-col font-sans"
            style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
          >
            {/* HEADER */}
            <div className="p-6 border-b border-gray-100 bg-gray-50/50 flex flex-col gap-4">
              <div className="flex justify-between items-start">
                <div className="flex flex-col gap-1">
                  <span
                    className={`px-2.5 py-1 rounded-full text-[10px] font-black uppercase w-fit ${badgeStyle.color}`}
                  >
                    {query.formCategory}
                  </span>
                  <h2 className="text-xl font-black text-[#0B1C2D]">
                    {query.formTitle}
                  </h2>
                </div>
                <button
                  onClick={onClose}
                  className="p-2 hover:bg-gray-100 rounded-full transition-colors"
                >
                  <span className="material-symbols-outlined">close</span>
                </button>
              </div>

              <div className="flex items-center justify-between">
                <span
                  className={`px-3 py-1 rounded-lg text-[9px] font-black uppercase ${query.priority === "high" ? "bg-red-50 text-red-600" : "bg-blue-50 text-blue-600"}`}
                >
                  Priority: {query.priority}
                </span>
                <select
                  value={currentStatus}
                  onChange={(e) => handleStatusChange(e.target.value)}
                  className="pl-3 pr-8 py-2 bg-white border border-gray-200 rounded-xl text-[10px] font-black uppercase outline-none hover:border-[#0B1C2D]"
                >
                  {STATUS_OPTIONS.map((opt) => (
                    <option key={opt} value={opt}>
                      {opt}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {/* CONTENT */}
            <div className="flex-1 overflow-y-auto p-6 space-y-8 custom-scrollbar">
              <div className="flex items-center gap-4 p-5 border border-slate-100 rounded-[24px] bg-white shadow-sm">
                <div className="w-12 h-12 rounded-2xl bg-[#0B1C2D] text-white flex items-center justify-center font-black text-lg uppercase">
                  {query.sender?.charAt(0)}
                </div>
                <div>
                  <h3 className="font-black text-[#0B1C2D] text-lg leading-none">
                    {query.sender}
                  </h3>
                  <p className="text-sm text-slate-500 mt-1">{query.email}</p>
                </div>
              </div>

              <div className="space-y-3">
                <h4 className="text-[10px] font-black text-slate-400 uppercase tracking-widest">
                  Inquiry Message
                </h4>
                <div className="bg-slate-50 p-5 rounded-[24px] border border-slate-100 text-sm text-[#0B1C2D] leading-relaxed italic">
                  "{query.description}"
                </div>
              </div>
            </div>

            {/* FOOTER */}
            <div className="p-6 border-t border-gray-100 bg-gray-50 grid grid-cols-2 gap-3">
              <button
                onClick={() => onAction("reply", query.id)}
                className="py-4 bg-[#0B1C2D] text-white rounded-2xl text-[10px] font-black uppercase tracking-widest flex items-center justify-center gap-2 shadow-lg shadow-[#0B1C2D]/20 transition-all active:scale-95"
              >
                <span className="material-symbols-outlined text-[18px]">
                  reply
                </span>{" "}
                Send Reply
              </button>
              <button
                onClick={() => {
                  onAction("delete", query.id);
                  onClose();
                }}
                className="py-4 bg-white border border-red-100 text-red-500 rounded-2xl text-[10px] font-black uppercase tracking-widest hover:bg-red-50 transition-all"
              >
                Delete Ticket
              </button>
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};

export default QueryDetailsDrawer;
